function generatePhotos (year: number, count: number, ext = "webp"): string[] {
  return [...Array(count)]
    .map((_, i) => `/img/gallery/${year}/${i + 1}.${ext}`)
}

export const photosByYear: Record<string, string[]> = {
  get 2023 () {
    return generatePhotos(2023, 22, "jpg")
  },
  get 2024 () {
    return generatePhotos(2024, 21)
  },
}
